export { CDN };

/**
 * danymically imported libraries from the CDN
 * 
 * @memberof vef
 */
class CDN {

    // paths to assets
    static url = "./";
    static libs = {};

    // cache for dynamic modules
    static cache_ = {};

    /**
     * Import a library based on the given key and store it in the cache
     * 
     * @param {string} key 
     * @returns {Promise} imported module
     */
    static import(key) {
        return new Promise((resolve, reject) => {
            if (key in CDN.libs) {
                const lib = CDN.libs[key];
                if (key in CDN.cache_) {
                    resolve(CDN.cache_[key]);
                } else if (typeof lib == "string") {
                    import(CDN.getAbsoluteURL(lib)).then(mod => {
                        CDN.cache_[key] = mod;
                        resolve(mod);
                    });
                } else if ((typeof lib == "object")) {
                    if (lib.css) {
                        let css = lib.css;
                        if (!Array.isArray(css)) css = [css];
                        for (let i = 0; i < css.length; ++i) {
                            if (typeof css[i] == "string") CDN.importCSS(CDN.getAbsoluteURL(css[i]));
                        }
                    }
                    if (typeof lib.js == "string") {
                        import(CDN.getAbsoluteURL(lib.js)).then(mod => {
                            CDN.cache_[key] = mod;
                            resolve(mod);
                        });
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            } else {
                reject();
            }
        })
    }

    /**
     * Add a new CSS link to the HTML header
     * 
     * @param {string} url 
     */
    static importCSS(url) {
        const css = document.createElement("link");
        css.rel = "stylesheet";
        css.href = url;
        document.head.appendChild(css);
    }

    /**
     * register libraries
     * 
     * @param {object} lib 
     */
    static register(lib) {
        Object.assign(CDN.libs, lib);
    }

    /**
     * Get the path to a library and join the baseurl if
     * the path does not have a protocol
     * 
     * @param {string} relativePath 
     * @returns {string} url
     */
    static getAbsoluteURL(relativePath) {
        if (relativePath.startsWith("http://") || relativePath.startsWith("https://")) {
            return relativePath;
        }

        let url = CDN.url;
        if (!url.endsWith("/")) url += "/";
        if (relativePath.startsWith("/")) relativePath = relativePath.slice(1);

        return url + relativePath;
    }

}